import { render, staticRenderFns } from "./backward.vue?vue&type=template&id=532cfd61&scoped=true&"
var script = {}
import style0 from "./backward.vue?vue&type=style&index=0&id=532cfd61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532cfd61",
  null
  
)

export default component.exports